import router from '../router'

export const debounce = (duration = 170) => {
  let timer
  return callback => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      callback()
    }, duration)
  }
}

export const viewNewsDetail = news => {
  news.local
    ? router.push({ name: 'news-detail', query: { news_id: news.id } })
    : window.open(news.url, '_block')
}



// WEBPACK FOOTER //
// ./src/utils/util.js